module.exports = __webpack_public_path__ + "media/navi/camera_kao_ninshiki-3704fde3.png";